import ListProcesses from "@/views/packing_house/quality_reports/process/ListProcesses.vue";
import ListTemplates from "@/views/packing_house/quality_reports/process/ListTemplates.vue";
import ShowTemplateMainRep from "@/views/packing_house/quality_reports/process/ShowTemplateMainRep.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "quality_reports",
  permission: "process",
});

export default [
  {
    path: "/ph/:packing_house_id/quality_reports/process/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_reports/process/:packing_house_process_id/list_templates",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_reports/process/:packing_house_process_id/show_template_rep/:quality_template_main_rep_id",
    name: routeName("show_template_rep"),
    component: ShowTemplateMainRep,
    props: true,
    meta: META
  }
];
